export default __webpack_public_path__ + "static/media/bkwp-picturemark-l.c356bf8a.svg";